import React, { useEffect, useState, useContext } from "react";
import { Row, Col, Accordion } from "react-bootstrap";
import minusImage from "../../public/images/minus.png";
import addImage from "../../public/images/add.png";
import styles from "./Portfolio.module.css";
import PortfolioSummary from "./PortfolioSummary";
import Stack from "./stack";
import { getPortfolioDetails, regenerateAllPortfolio } from "../../api";
import Stock from "./stock";
import Etf from "./etf";
import { Button, Spinner } from "../../Common";
import withFeatureActions from "../../withFeatureActions";
import StackComponent from "./stack";
import StockComponent from "./stock";
import EtfComponent from "./etf";

const title = ["Portfolio Summary", "Stacks", "Stocks", "ETFs"];

const Portfolio = ({ custId , featureAccess}) => {
  const [stack, setStack] = useState([]);
  const [stock, setStock] = useState([]);
  const [etf, setEtf] = useState([]);
  const [activeTab, setActiveTab] = useState("holding");
  const [pendingData, setPendingData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [openSections, setOpenSections] = useState({
    stack: false,
    stock: false,
    etf: false,
  });
  
  const Etf = withFeatureActions(EtfComponent, "INVESTING", "Portfolio");
  const Stock = withFeatureActions(StockComponent, "INVESTING", "Portfolio");
  const Stack = withFeatureActions(StackComponent, "INVESTING", "Portfolio");
  const toggleSection = (section) => {
    setOpenSections((prevState) => ({
      ...prevState,
      [section]: !prevState[section],
    }));
  };

  const getDetails = async (custId) => {
    setIsLoading(true);
    try {
      const resp = await getPortfolioDetails(custId);
      let arrstack = [];
      let arrstock = [];
      let arretf = [];
      resp.holdings.map((item) => {
        if (item.type === "stack") {
          arrstack.push(item);
        } else if (item.type === "stock") {
          arrstock.push(item);
        } else {
          arretf.push(item);
        }
      });
      setStack(arrstack);
      setStock(arrstock);
      setEtf(arretf);
      setPendingData(resp.pendingData || []);
    } catch (e) {}
    setIsLoading(false);
  };
  const regenerateAllButton = async () => {
    try {
      setLoading(true);
      const response = await regenerateAllPortfolio(custId, "all", "all");

      if (response && response.code === 200) {
        setMessage("Process is initiated, please wait");
        // setLoading(false);
        setTimeout(async () => {
          // setLoading(true);
          await refreshPortfolio();
          setLoading(false);
          setTimeout(() => setMessage(""), 2000);
        }, 1000);
      } else {
        setMessage(response.data.message);
        setLoading(false);
        setTimeout(() => setMessage(""), 3000);
      }
    } catch (error) {
      setMessage("Failed to regenerate portfolio");
      setLoading(false);
      setTimeout(() => setMessage(""), 3000);
    }
  };
  const refreshPortfolio = async () => {
    await getDetails(custId);
  };

  useEffect(() => {
    getDetails(custId);
  }, [custId]);

  return (
    <div>
      <div>
        <Row className={`mb-3 ${styles.tableTitle}`}>
          <Col className="pl-0" xs={10}>
            <span>{title[0]}</span>
          </Col>
        </Row>
        <PortfolioSummary custId={custId} />
      </div>
      <hr />
      <div className={styles.tabContainer}>
        <button
          className={`${styles.tabButton} ${
            activeTab === "holding" ? styles.activeTab : ""
          }`}
          onClick={() => setActiveTab("holding")}
        >
          Holding
        </button>
        <button
          className={`${styles.tabButton} ${
            activeTab === "order" ? styles.activeTab : ""
          }`}
          onClick={() => setActiveTab("order")}
        >
          Order
        </button>
      </div>
      {isLoading && <Spinner />}

      {activeTab === "holding" && !isLoading ? (
        <>
          {message && (
            <div
              style={{
                margin: "10px 0",
                padding: "10px",
                backgroundColor: "#ddffdd",
                borderRadius: "4px",
              }}
            >
              {message}
            </div>
          )}
          <div className={styles.regenerateButton}>
            <div style={{width:"160px"}}>
              
            {featureAccess?.writeAccess && (
              <Button
                title="Regenerate All"
                loading={loading}
                onClick={() => regenerateAllButton()}
              />
            )}
            </div>
          </div>

          <Accordion>
            <div>
              <ContextAwareToggle
                eventKey="stock"
                value={stock.length}
                title={title[2]}
                onClick={() => toggleSection("stock")}
                isOpen={openSections.stock}
              ></ContextAwareToggle>
              <Accordion.Collapse in={openSections.stock}>
                <Stock
                  stock={stock}
                  custId={custId}
                  refreshPortfolio={refreshPortfolio}
                />
              </Accordion.Collapse>
              <hr />
            </div>
            <div>
              <ContextAwareToggle
                eventKey="stack"
                title={title[1]}
                value={stack.length}
                onClick={() => toggleSection("stack")}
                isOpen={openSections.stack}
              />
              <Accordion.Collapse in={openSections.stack}>
                <Stack
                  stack={stack}
                  custId={custId}
                  refreshPortfolio={refreshPortfolio}
                />
              </Accordion.Collapse>
              <hr />
            </div>

            <div style={{ marginBottom: "240px" }}>
              <ContextAwareToggle
                eventKey="etf"
                value={etf.length}
                title={title[3]}
                onClick={() => toggleSection("etf")}
                isOpen={openSections.etf}
              ></ContextAwareToggle>
              <Accordion.Collapse in={openSections.etf}>
                <Etf etf={etf} custId={custId} refreshPortfolio={refreshPortfolio} />
              </Accordion.Collapse>
            </div>
          </Accordion>
        </>
      ) : activeTab === "order" && !isLoading ? (
        <div className={styles.pendingOrdersContainer}>
          <Row style={{ margin: "10px 10px" }}>
            <Col className={styles.stockHeading}>Ticker</Col>
            <Col className={styles.stockHeading}>Name</Col>
            <Col className={styles.stockHeading}>Status</Col>
            <Col className={styles.stockHeading}>Investment Amount</Col>
            <Col className={styles.stockHeading}>Created Date</Col>
            <Col className={styles.stockHeading}>Comment</Col>
          </Row>

          {pendingData.length > 0 ? (
            pendingData.map((item, index) => (
              <Row key={index} style={{ margin: "10px 10px" }}>
                <Col className={styles.stockTitle}>{item.ticker || "--"}</Col>
                <Col className={styles.stockTitle}>{item.name || "--"}</Col>
                <Col className={styles.stockTitle}>{item.status || "--"}</Col>
                <Col className={styles.stockTitle}>
                  {item.investmentAmount || "--"}
                </Col>
                <Col className={styles.stockTitle}>
                  {new Date(item.created).toLocaleDateString() || "--"}
                </Col>
                <Col className={styles.stockTitle}>{item.comment || "--"}</Col>
              </Row>
            ))
          ) : (
            <Row
              style={{ margin: "10px 10px", textAlign: "left", color: "gray" }}
            >
              <Col>
                <span>No pending orders found</span>
              </Col>
            </Row>
          )}
        </div>
      ) : null}
    </div>
  );
};

function ContextAwareToggle({
  value,
  title,
  eventKey,
  callback,
  isOpen,
  onClick,
}) {
  return (
    <Row onClick={onClick} className={`mb-3 ${styles.tableTitle}`}>
      <Col className="pl-0" xs={10}>
        <span>{title}</span>
        {value > 0 && <span className={styles.totalSum}>{value}</span>}
      </Col>
      <Col md={2} xs={2} style={{ textAlign: "end", paddingRight: "0px" }}>
        <img
          alt=""
          src={isOpen ? minusImage : addImage}
          className={styles.accordionIcon}
          style={{ cursor: "pointer" }}
        ></img>
      </Col>
    </Row>
  );
}

export default withFeatureActions(Portfolio, "INVESTING", "Portfolio");

